import React, { VFC } from 'react'
import styled, { css } from 'styled-components'

import {
  PersonalizationInfoList,
  PersonalizationSubTitle,
} from '@Components/Personalization/Styles/Personalization.styled'
import { up } from '@Globals/Style/breakpoints'
import { useTranslation } from '@Globals/Translations'

import { UVInfoList } from './uvprint.styled'

const StyledSubTitle = styled(PersonalizationSubTitle)`
  margin: 0 0 16px;
  flex: 1 1 100%;
  font-size: 18px;
`

interface Props {
  price: string
  step: number
}

const ListWrapper = styled.div<{ step: number }>(({ step }) => css`
  display: flex;
  flex-direction: column;

  ${PersonalizationInfoList} {
    max-width: unset;
    width: 100%;

    li {
      max-width: unset;

      ${up('tablet')} {
        max-width: 320px;
      }
    }
  }

  ${step === 2 && css`
    ${PersonalizationInfoList} {
      margin-bottom: 0;
      margin-top: 0;

      &:last-of-type {
        margin-bottom: 20px;
      }
    }

    ${up('tablet')} {
      flex-direction: row;
      flex-wrap: wrap;

      ${PersonalizationInfoList} {
        width: 50%;

        li {
          max-width: inherit;
        }
      }
    }
  `}
`)
export const UVPrintInfo: VFC<Props> = ({ price, step }) => {
  const { t } = useTranslation('products')

  return (
    <ListWrapper step={step}>
      <StyledSubTitle>{t('UV_PRINT_ABOUT_TITLE')}</StyledSubTitle>
      {step === 1 && (
        <UVInfoList>
          <li>{t('UV_PRINT_ABOUT_INFO_1')}</li>
          <li>{t('UV_PRINT_ABOUT_INFO_2')}</li>
          <li>{t('UV_PRINT_ABOUT_INFO_3')}</li>
          <li>{t('UV_PRINT_ABOUT_INFO_4')}</li>
          <li>{t('UV_PRINT_ABOUT_INFO_5')}</li>
          <li>{t('UV_PRINT_ABOUT_PRICE', { arg1: price })}</li>
        </UVInfoList>
      )}
      {step === 2 && (
        <>
          <PersonalizationInfoList>
            <li>{t('UV_PRINT_ABOUT_INFO_1')}</li>
            <li>{t('UV_PRINT_ABOUT_INFO_2')}</li>
            <li>{t('UV_PRINT_ABOUT_INFO_3')}</li>
          </PersonalizationInfoList>
          <PersonalizationInfoList>
            <li>{t('UV_PRINT_ABOUT_INFO_4')}</li>
            <li>{t('UV_PRINT_ABOUT_INFO_5')}</li>
            <li>{t('UV_PRINT_ABOUT_PRICE', { arg1: price })}</li>
          </PersonalizationInfoList>
        </>
      )}
    </ListWrapper>
  )
}
